"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const paths = () => [React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.24998 11.0007V6.50065H9.74998V11.0007H8.24998Z"
}), React.createElement("path", {
  d: "M9.74998 12.7507C9.74998 13.1649 9.41419 13.5007 8.99998 13.5007C8.58576 13.5007 8.24998 13.1649 8.24998 12.7507C8.24998 12.3364 8.58576 12.0007 8.99998 12.0007C9.41419 12.0007 9.74998 12.3364 9.74998 12.7507Z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.7526 14.7507H15.2473L8.99998 3.08889L2.7526 14.7507ZM0.838867 15.1465L8.33887 1.14648H9.66109L17.1611 15.1465L16.5 16.2507H1.49998L0.838867 15.1465Z"
})];
const WarningTriangleSmall = _ref => {
  let {
    prefix
  } = _ref;
  return React.createElement(_ssrIcon.default, {
    className: `${prefix}price-module__small-icon`,
    viewBox: "0 0 18 18",
    paths: paths
  });
};
WarningTriangleSmall.defaultProps = {
  prefix: ''
};
var _default = WarningTriangleSmall;
exports.default = _default;